<template>
  <div :style="'height: 100%; background: ' + backgroundColor">
    <v-container>
      <v-card elevation="0" :style="'background: ' + backgroundColor">
        <div v-if="!hideReportBuilderInfo">
          <div class="md-header">
            Report Builder
            <v-progress-circular
              class="ml-3"
              :active="true"
              :indeterminate="true"
              v-if="generatingReport"
            />
          </div>
          <div class="md-body">
            To view, select the name of the store and report in the drop-down
            menu. Then select the format.
          </div>
          <!--
            Repointed from the deleted `/distributor/guides/reports/0`
            (legacy help teardown, `docs/user/HELP-SYSTEM-DESIGN.md`
            decision 5) to the markdown-backed help index.
          -->
          <div class="md-body">
            <div
              @click="$router.push('/distributor/help/owner')"
              class="link"
              color="primary"
              data-testid="report-builder-help-link"
            >
              View Help
            </div>
          </div>
        </div>
        <v-form class="mt-3">
          <v-row align="center">
            <v-col cols="12" sm="4">
              <v-menu offset-y>
                <template v-slot:activator="{ props: menuProps }">
                  <v-tooltip location="bottom">
                    <template v-slot:activator="{ props: tooltipProps }">
                      <v-btn
                        class="extended-fab batch-selector-btn"
                        v-bind="{ ...menuProps, ...tooltipProps }"
                        size="large"
                        variant="flat"
                        style="margin-bottom: 16px"
                      >
                        <div style="color: var(--tf-accent-crimson-dark)" class="ellipsis-batch ml-1">
                          <div>
                            {{
                              (selectedBatch.name === "Pending Orders"
                                ? "Pending Orders Report"
                                : selectedBatch.name) +
                                (selectedBatch.created_at
                                  ? " - " + selectedBatch.created_at
                                  : "") +
                                (selectedBatch.distributor_po
                                  ? " - PO: " + selectedBatch.distributor_po
                                  : "")
                            }}
                          </div>
                        </div>
                        <v-spacer />
                        <v-icon color="#3B0603" class="extended-fab-icon"
                          >expand_more</v-icon
                        >
                      </v-btn>
                    </template>
                    <span> Select batch to view relevant reporting </span>
                  </v-tooltip>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(item, index) in batches"
                    :key="index"
                    @click="selectBatch(item)"
                  >
                    <v-list-item-title>
                      <div class="d-flex align-center">
                        <div
                          v-if="index > 1"
                          class="mr-1 batch-dropdown-label"
                        >
                          Batch
                        </div>
                        <div>
                          {{
                            (item.name === "Pending Orders"
                              ? "Pending Orders Report"
                              : item.name) +
                              (item.created_at
                                ? " - " + item.created_at
                                : "") +
                              (item.distributor_po
                                ? " - PO: " + item.distributor_po
                                : "")
                          }}
                        </div>
                      </div></v-list-item-title
                    >
                  </v-list-item>
                </v-list>
              </v-menu>
              <!--
              <v-select
                v-model="selectedBatch.id"
                @change="changeBatchId"
                :items="campaignBatchList"
                item-title="name"
                item-value="id"
              >
              </v-select>
              -->
            </v-col>
            <!--
            <v-col xs12 sm4>
              <v-autocomplete
                :loading="storesPending"
                :no-data-text="
                  storesPending
                    ? 'Loading... Please wait'
                    : 'No data available'
                "
                :disabled="lockedCampaign"
                :items="campaigns"
                v-model="selectedStore"
                @update:model-value="changeCampaign"
                label="Store"
                item-title="name"
                return-object
                class="report-field"
              >
                <template v-slot:selection="{ item }">
                  <p v-if="item.complete">
                    {{ item.name }},
                    <b>Distributor PO:</b>
                    {{ item.distributor_po }}
                  </p>
                  <p v-else>{{ item.name }}</p>
                </template>

                <template v-slot:item="{ item }">
                  <p v-if="item.complete">
                    {{ item.name }},
                    <b>Distributor PO:</b>
                    {{ item.distributor_po }}
                  </p>
                  <p v-else>{{ item.name }}</p>
                </template>
              </v-autocomplete>
            </v-col>
          -->
          </v-row>
        </v-form>
        <div v-if="selectedStore">
          <!-- Presence-only automation marker: the availability fetch for this
               store has finished, so an empty card list is the real answer and
               not a list that has not loaded yet. -->
          <span v-if="reportsLoaded" data-testid="report-builder-loaded" hidden />
          <div v-for="(reportGroup, index) in visibleReportGroups" :key="index">
            <div
              v-if="!isClientAdmin && reportGroup.groupName"
              class="md-subheader-no-spacing"
            >
              {{ reportGroup.groupName }}
            </div>
            <div v-if="!isClientAdmin" class="md-body">
              {{ reportGroup.groupDescription }}
            </div>
            <v-row class="mb-5">
              <v-col
                cols="12"
                v-for="(report, ind) in reportGroup.groupReports"
                :key="ind"
              >
                <report-card
                  :completedReports="completedReports"
                  :report="report"
                  :showPdfBtn="
                    getPdfBlacklistReport.indexOf(report.reportName) === -1
                  "
                  :showCsvBtn="
                    getCsvBlacklistReport.indexOf(report.reportName) === -1
                  "
                  @btnClick="reportBtnClick"
                  :enableButtons="
                    !!availableReports.find(
                      (availableReport) =>
                        availableReport.name === report.reportName
                    )
                  "
                  :campaign="selectedStore ? selectedStore : {}"
                  :batchName="selectedBatch.name"
                />
              </v-col>
            </v-row>
          </div>
        </div>
        <div v-else>
          <h3>Please select store to show reports</h3>
        </div>
      </v-card>

      <campaign-complete-dialog
        v-if="completeCampaignDialogOpened"
        :campaign="selectedStore"
        :modalPopped="completeCampaignDialogOpened"
        @complete-campaign="completeCampaign"
        @close-modal="closeCompleteDialog"
      />
    </v-container>
  </div>
</template>

<script>
import { describeError } from "@/utils/safeErrorLog";
import { reopenedCloseDate } from "@/pages/distributor/store-editor/storeWindow.js";
import CampaignCompleteDialog from "@/pages/distributor/store-editor/StoreCompleteDialog";
import { mapGetters } from "vuex";
import ReportCard from "./ReportCard";
import store from "@/store";
import helpers from "@/mixins/helpers";
import { usePermissions } from "@/composables/usePermissions";

export default {
  setup() {
    // Expose capability helpers to the Options API.  The role-name string
    // checks (Vuex account.role.name / localStorage.roleName) are replaced by
    // capability checks so the ACL stays correct even when role names change.
    const { can, cannot } = usePermissions();
    return { can, cannot };
  },

  props: {
    reportSlug: {
      type: String,
      required: false,
    },
    preSelectedCampaign: {
      type: Object,
      default: null,
    },
    backgroundColor: {
      type: String,
      required: false,
      default: "#FFFFFF",
    },
    hideReportBuilderInfo: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  mixins: [helpers],

  components: {
    "campaign-complete-dialog": CampaignCompleteDialog,
    "report-card": ReportCard,
  },

  data() {
    return {
      campaigns: [],
      storesPending: false,

      availableReports: [],
      reportsLoaded: false,

      selectedStore: null,
      selectedReport: null,
      lockedCampaign: false,

      providedParams: {},
      providedFilters: {},
      providedSort: null,

      filterVariants: {},

      completeCampaignDialogOpened: false,
      reportsPending: false,
      generatingReport: false,
      completedReports: [],
      campaignBatchList: [],
      batches: [
        { name: "Pending Orders", id: null },
        { name: "Store Product Reports", id: 0 },
      ],
      selectedBatch: { name: "Store Product Reports", id: 0 },
    };
  },

  computed: {
    ...mapGetters([
      "getPdfBlacklistReport",
      "getCsvBlacklistReport",
      "getReportGroups",
    ]),

    reportGenerationAllowed() {
      if (!this.selectedStore || !this.selectedReport) {
        return false;
      }
      return true;
    },
    // The campaign-completion guard was deleted (plan 5.6): no template or
    // method in this component referenced it. ReportGenerator.vue has the
    // live sibling using can("campaign.edit").
    isClientAdmin() {
      // Migrated from role.name == "Client Admin" to capability check (plan 5.6).
      // store.reporting is the /report route gate and is held by:
      //   SE (explicit grant), Owner (all-minus-superadmin), SA (all caps).
      // Client Admin and Store Manager do NOT hold store.reporting, so
      // cannot("store.reporting") exactly preserves the original role set.
      return this.cannot("store.reporting");
    },

    visibleReportGroups() {
      const visibleReportGroups = [];
      const reportGroups = JSON.parse(JSON.stringify(this.getReportGroups));

      reportGroups.forEach((group) => {
        const visibleReports = [];
        group.groupReports.forEach((report) => {
          // if report name is in availableReports
          // push to visibleReports

          let hideReport = false;

          if (report.requireOrders && !this.selectedBatch.has_orders) {
            hideReport = true;
          }

          if (report.hideWhenBatchSelected && this.selectedBatch.id != 0) {
            hideReport = true;
          }

          if (!report.isStoreReport && this.selectedBatch.id == 0) {
            hideReport = true;
          }

          if (
            !hideReport &&
            this.availableReports.find(
              (availableReport) => availableReport.name === report.reportName
            )
          ) {
            visibleReports.push(report);
          }
        });
        const groupInfo = group;
        groupInfo.groupReports = visibleReports;
        if (visibleReports.length > 0) {
          visibleReportGroups.push(groupInfo);
        }
      });
      return visibleReportGroups;
    },
  },

  watch: {
    preSelectedCampaign: function(newVal, oldVal) {
      if (newVal) {
        this.selectedStore = newVal;
        this.changeCampaign(this.selectedStore);
      }
    },
  },
  mounted() {
    // loadCampaign and available reports
    if (this.preSelectedCampaign) {
      this.selectedStore = this.preSelectedCampaign;
      this.changeCampaign(this.selectedStore);
    }
    this.loadStores();
    this.loadCompletedReports();
  },

  methods: {
    selectBatch(item) {
      this.selectedBatch = item;
      this.loadReports(this.selectedStore.id);
    },

    async getBatches(selCampaign) {
      try {
        const response = await this.$axios.get(
          `/batch/getBatches/${selCampaign.id}`
        );
        this.batches = [{ name: "Store Product Reports", id: 0 }];
        // add response.data to batches
        this.batches = [...this.batches, ...response.data];
      } catch (err) {
        console.log(describeError(err));
      }
    },

    reportHidden(report) {
      const reportEnabled = this.reportEnabled(report);
      const reportInCompletedReports = this.completedReports.includes(
        report.reportName
      );
      const hidden =
        (!reportEnabled && !reportInCompletedReports) ||
        (!reportEnabled &&
          reportInCompletedReports &&
          this.selectedStore.complete) ||
        (report.requireOrders && !this.selectedStore.has_orders);
      return hidden;
    },

    reportEnabled(report) {
      const reportAvailable = this.availableReports.find(
        (availableReport) => availableReport.name === report.reportName
      );
      return reportAvailable != null;
    },

    async changeCampaign(selCampaign) {
      if (selCampaign && selCampaign.id) {
        await this.getBatches(selCampaign);
      }
      this.selectedBatch = this.batches[0];
      await this.loadReports(selCampaign.id);
      this.$emit("changeCampaign", selCampaign);
    },

    async loadCompletedReports() {
      this.storesPending = true;

      try {
        const result = await this.$axios.get(`/reports/get_completed_reports`);
        this.completedReports = result.data;
      } catch (err) {
        console.log(describeError(err));
      }
    },

    async loadStores() {
      this.storesPending = true;
      try {
        const result = await this.$axios.get(`/campaign/getReportCampaignList`);
        this.campaigns = result.data;
        this.storesPending = false;
      } finally {
        this.storesPending = false;
      }
    },

    async loadReports(campaign_id) {
      // load available reports
      if (campaign_id) {
        this.reportsPending = true;
        this.reportsLoaded = false;
        try {
          const reports = await this.$axios.get(
            `/reports/${campaign_id}/${this.selectedBatch.id}`
          );
          this.availableReports = reports.data;
          this.reportsLoaded = true;
          if (this.availableReports.length > 0) {
            if (
              !this.selectedReport ||
              this.availableReports
                .map(function(e) {
                  return e.name;
                })
                .indexOf(this.selectedReport.name) == -1
            ) {
              this.selectedReport = this.availableReports[0];
            }
          }
        } finally {
          this.reportsPending = false;
        }
      }
    },

    generateReport(reportFormat) {
      this.generatingReport = true;
      this.$emit(
        "submit",
        this.selectedStore,
        this.selectedReport,
        this.availableReports,
        reportFormat,
        this.selectedBatch.id
      );
    },

    openCompleteDialog() {
      if (this.selectedStore && !this.selectedStore.complete) {
        this.completeCampaignDialogOpened = true;
      }
    },

    closeCompleteDialog() {
      this.completeCampaignDialogOpened = false;
    },

    async completeCampaign(campaign, distributorPO) {
      this.completeCampaignPending = true;

      try {
        campaign.complete = true;
        campaign.distributor_po = distributorPO;
        if (campaign.active) {
          campaign.end_date = reopenedCloseDate(campaign);
        }
        this.closeCompleteDialog();
        const result = await this.$axios.get(
          `/campaign/setLockStatusCampaign/${campaign.id}/${campaign.complete}/${campaign.distributor_po}/${campaign.end_date}`
        );
        await this.$axios.get(
          `/campaign/sendEmailAfterLockCampaign/${campaign.id}`
        );
      } finally {
        this.completeCampaignPending = false;
        this.loadReports(campaign.id);
      }
    },
    reportBtnClick(reportFormat, selectedReport) {
      this.$emit(
        "submit",
        this.selectedStore,
        this.availableReports.find(
          (report) => report.name === selectedReport.reportName
        ),
        this.availableReports,
        reportFormat,
        selectedReport,
        this.selectedBatch.id
      );
    },
  },
};
</script>

<style scoped>
.report-field p {
  margin-bottom: 0px;
}

.link {
  text-decoration: underline;
  cursor: pointer;
}

.report-button {
  width: 100%;
  min-width: 100px;
  margin: 0;
}

.large-report-button {
  min-width: 240px;
  width: 100%;

  margin: 0;
}
.reportGroupName {
  margin-top: 40px;
  font-size: 22px !important;
  font-weight: 700;
}
.reportGroupDescription {
  font-size: 16px !important;
}

.batch-dropdown-label {
  font-weight: 500;
  color: rgb(177, 36, 25, 1);
}
</style>

